import Report from '@klook/client-report'

const klkReport = new Report({
    platform: "desktop", 
    url: process.env.NODE_ENV === "production" ?  "https://log.klook.com/v3/frontlogsrv/log/web" : "https://dev-frontsrv-new.dev.klook.io/v3/frontlogsrv/log/web"
})

export default klkReport; 